import { baseApi } from "../baseApi";

const selectInputApis = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPriorities: builder.query<any, void>({
      query: () => "/gw/priorities",
    }),
    getCategories: builder.query<any, void>({
      query: () => "/gw/categories",
    }),
    getSubcategories: builder.query<any, number | void>({
      query: (categoryId) =>
        categoryId
          ? `/gw/subcategories?category_id=${categoryId}`
          : "/gw/subcategories",
    }),
    getClients: builder.query<any, Record<string, any> | void>({
      query: (filter) => {
        const queryParams = filter
          ? new URLSearchParams(filter).toString()
          : "";
        return queryParams ? `/clients?${queryParams}` : "/clients";
      },
      providesTags: (result, error, filter) => [
        { type: "Client", id: filter ? JSON.stringify(filter) : "ALL" },
      ],
    }),
    getStatuses: builder.query<any, void>({
      query: () => "/gw/status",
    }),
    getUpdateReasons: builder.query<any, void>({
      query: () => "/gw/update-reasons",
    }),
    getAgents: builder.query<any, void>({
      query: () => "/agents",
    }),
  }),
});

export const {
  useGetPrioritiesQuery,
  useGetCategoriesQuery,
  useGetSubcategoriesQuery,
  useGetClientsQuery,
  useLazyGetClientsQuery,
  useGetStatusesQuery,
  useGetUpdateReasonsQuery,
  useGetAgentsQuery,
} = selectInputApis;
